//181
import { useGLTF } from '@react-three/drei';
import { Shadow } from './_shadow';
import React, { useContext, useEffect, useRef, useState } from 'react';
import CurrentContext from '../../utils/CurrentContext';
import useSetMaterialFinish from '../../utils/useSetMaterialFinish';
import { handleExportGLTF } from '../../utils/jsHelper';
import { PaintColorMaterial } from '../../utils/materials';

export function Addy_side_table(props) {
  const { nodes, materials, scene } = useGLTF('models/Addy Side Table.glb');

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);

  useSetMaterialFinish(
    PaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-addy_side_table-paint_color',
    aoIntensity,
  );

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      <mesh
        castShadow
        geometry={nodes.Paint_Color.geometry}
        material={PaintColorMaterial}
      />
      <Shadow model={'Addy Side Table'} />
    </group>
  );
}
